// @flow
import React, { Component } from 'react';
import type { PartnerSequence } from 'store/modules/partners';
import { connect } from 'react-redux';
import type { State } from 'store';

import PartnerSequences from 'components/partner/PartnerSequences/PartnerSequences';

type Props = {
  sequences: ?(PartnerSequence[]),
  username: string,
  currentPartnerId: string,
};

class PartnerSequencesContainer extends Component<Props> {
  render() {
    const { sequences, username, currentPartnerId } = this.props;

    return (
      <PartnerSequences
        sequences={sequences}
        username={username}
        currentPartnerId={currentPartnerId}
      />
    );
  }
}

export default connect(
  ({ partners }: State) => ({
    sequences: partners.sequences,
    currentPartnerId: partners.partner && partners.partner.id,
  }),
  () => ({}),
)(PartnerSequencesContainer);



// WEBPACK FOOTER //
// ./src/containers/partner/PartnerSequencesContainer.js